export default {
  'employees-navigation-item': 'Werknemers',
  'reports-of-sickness-navigation-item': 'Verzuimen',
  'work-stock-navigation-item': 'Werkvoorraad',

  'unknown': 'Onbekend',
  'optional': 'optioneel',
  'not-applicable': 'Niet van toepassing',
  'VZM': 'Verzuim',
  'WIA': 'WIA',
  'Female': 'Vrouw',
  'Male': 'Man',
  'no': 'Nee',
  'yes': 'Ja',
  'false': 'Nee',
  'true': 'Ja',

  'general': {
    'report-on': 'melding op'
  },

  'modals': {
    'logout-confirmation-title': 'Uitloggen',
    'logout-confirmation-text': 'Wilt u uitloggen uit het gegevensportaal en AeviConnect?',
    'logout-confirmation-confirm': 'Ja, ik wil uitloggen'
  },

  'input': {
    'placeholders': {
      'choose-file': 'Kies een bestand',
      'who-are-you-looking-for': 'Naar wie bent u op zoek?',
      'which-report-of-sickness-are-you-looking-for': 'Naar welk verzuim bent u op zoek?',
      'which-work-stock-item-are-you-looking-for': 'Werkvoorraad zoekopdracht'
    }
  },

  'buttons': {
    'previous-step': 'Terug naar de vorige stap',
    'next-step': 'Door naar de volgende stap',
    'cancel': 'Annuleren',
    'edit': 'Wijzigen',
    'close': 'Sluiten'
  },

  'forms': {
    'no-entry': 'Niet ingevuld'
  },

  'genders': {
    'male': 'Man',
    'female': 'Vrouw'
  },

  'states': {
    'Received': 'Ontvangen',
    'Approved': 'Goedgekeurd',
    'Rejected': 'Afgekeurd',
    'ToReview': 'Ter beoordeling',
    'Processing': 'In behandeling',
    'Removed': 'Verwijderd',
    'Corrected': 'Gecorrigeerd',
    'Processed': 'Verwerkt',
    'Modified': 'Aangepast',
    'Open': 'Lopend',
    'Closed': 'Gesloten',
    'RemovedForCorrection': 'Verwijderd ter correctie'
  },

  'validation-messages': {
    'field-required': 'Dit is een vereist veld.',
    'employee': {
      'date-of-birth-may-not-exceed-death': 'Datum overlijden kan niet vóór de geboortedatum liggen.',
      'initials-invalid-format': 'Voorletters moeten voldoen aan een format zoals: A.B.C.'
    },
    'employment-relationship': {
      'from-date-greater-than-until-date': 'Datum \'In Dienst Sinds\' later dan datum \'Uit Dienst Sinds.\'',
      'employee-number-exceed-char-limit': 'Personeelsnummer mag niet meer dan 25 karakters bevatten.',
      'cannot-be-absent-on-from-date': 'Werknemer mag niet verzuimen op datum in dienst.'
    },
    'report-of-sickness': {
      'no-value-was-changed': 'Verander ten minste één veld om een wijziging te maken in het verzuim.'
    },
    'recovery': {
      'no-value-was-changed': 'Verander ten minste één veld om een wijziging te maken in de herstelmelding.'
    },
    'period': {
      'no-value-was-changed': 'Verander ten minste één veld om de wijziging te bewerken.'
    },

    'disability-rate-format-invalid': 'Het arbeidsongeschiktheidspercentage moet aan het volgende formaat voldoen: \'xxx,xx%\'',
    'disability-rate-value-too-high': 'Een arbeidsongeschiktheidspercentage boven 100,00% is niet toegestaan.',
    'disability-rate-value-too-low': 'Een arbeidsongeschiktheidspercentage onder 1,00% is niet toegestaan.',
    'disability-rate-value-equal-to-previous': 'Het arbeidsongeschiktheidspercentage mag niet gelijk zijn aan het huidige percentage.'
  },

  'errors': {
    'provide-all-required-fields': 'Vul alle verplichte velden in.',
    'provide-all-required-fields-and-atleast-one-change': 'Vul alle gegevens in en doe op z\'n minst één wijziging.',
    'no-results-found': 'Geen resultaten gevonden',
    'no-results-found-for': 'Geen resultaten gevonden voor',
    'no-data-found': '(nog) geen data gevonden'
  },

  'header': {
    'income': 'Inkomen',
    'care': 'Zorg',
    'damages': 'Schade',
    'company-care': 'Bedrijfszorg'
  },

  'work-stock': {
    'overview': {
      'title': 'Werkvoorraad',
      'text': 'Onderstaand overzicht bevat de items waarvoor, voordat ze verder verwerkt kunnen worden, een beoordeling van een interne medewerker nodig is. De afgehandelde items vanuit de werkvoorraad blijven zichtbaar in de lijst.'
    },
    'details': {
      'title': 'Werkvoorraad item',
      'text': 'Op deze pagina kan een interne medewerker een item op de werkvoorraad beoordelen. De medewerker moet, om te kunnen accepteren of weigeren, het item eerst in behandeling nemen. Na afhandeling wordt ook de relevante informatie over de beoordeling hier getoond.'
    },
    'states': {
      'New': 'Nieuw',
      'Reviewing': 'In behandeling',
      'Closed': 'Afgehandeld'
    },
    'reasons': {
      'FirstSickDayMoreThan5DaysInPast': 'Eerste verzuimdag meer dan 5 dagen in het verleden.'
    },
    'modals': {
      'item-current-processing-start-review-title': 'Item in Behandeling Nemen',
      'item-current-processing-start-review-text': 'De schade uitkering wordt op dit moment berekend. U kunt het item niet in behandeling nemen.',
      'item-current-processing-judge-item-title': 'Werkvoorraad Item Beoordelen',
      'item-current-processing-judge-item-text': 'De schade uitkering wordt op dit moment berekend. U kunt het item niet beoordelen.'
    },
    'fields': {
      'id': 'Identificatie',
      'employer': 'Werkgever',
      'employee': 'Werknemer',
      'employerCustomerNumber': 'Werkgever klantnr.',
      'employeeCustomerNumber': 'Werknemer klantnr.',
      'action': 'Actie',
      'actions': {
        'UPDATE': 'Bijwerken',
        'REGISTER': 'Aanmaken',
        'UWV': 'Aanmaken'
      },
      'work-stock-type': 'Type',
      'work-stock-types': {
        'ReportOfSickness': 'Ziekmelding',
        'UwvDescision': 'UWV beslissing',
        'UwvDecision': 'UWV beslissing'
      },
      'reason': 'Reden',
      'treatedBy': 'Behandeld door',
      'status': 'Status',
      'createdOn': 'Aangemaakt op'
    }
  },

  'employee': {
    'initials': 'Voorletters',
    'last-name': 'Achternaam',
    'last-name-prefixes': 'Voorvoegsels achternaam',
    'last-name-partner': 'Geboortenaam',
    'last-name-partner-prefixes': 'Voorvoegsels geboortenaam',
    'name': 'Naam',
    'name-partner': 'Geboortenaam',
    'date-of-birth': 'Geboortedatum',
    'date-of-death': 'Overlijdensdatum',
    'id': 'Personeelsnummer',
    'id-abrev': 'Personeelsnr.',
    'gender': 'Geslacht',
    'address': 'Adres',
    'e-mail': 'E-Mail',
    'social-security-number': 'BSN',
    'registration-date': 'In dienst sinds',
    'termination-date': 'Uit dienst sinds',
    'employment-from-date': 'In dienst sinds',
    'employment-until-date': 'Uit dienst sinds',
    'personel-number': 'Personeelsnummer',
    'yearly-salary': 'Bruto jaarsalaris',
    'gross-annual-salary': 'Bruto jaarsalaris',
    'sv-salary': 'Loon voor werknemersverzekeringen',
    'profession-class': 'Beroepsklasse',
    'kind-of-employment': 'Aard dienstverband',
    'nature-of-employment': 'Aard dienstverband',
    'characteristics-from-date': 'Ingangsdatum kenmerken',
    'no-risk': 'No risk',
    'profession-classification': 'Beroepsklasse',
    'not-married': 'Ongehuwd'
  },

  'employees': {
    'overview': 'Mijn werknemers',
    // 'index-title': 'Dit is het overzicht van uw medewerkers zoals deze bij Aevitae staan geregistreerd. U kunt medewerkers zoeken met behulp van de zoekbalk en filters hieronder. Wanneer u een medewerker selecteert navigeert u naar zijn detail-pagina. Hier vind u een verzameling van zijn gegevens.',
    'index-title': 'Dit is het overzicht van uw medewerkers zoals deze bij Aevitae staan geregistreerd. Wilt u een medewerker zoeken? Klik dan op "Naar wie bent u op zoek?" en vul daar de naam, de geboortedatum of het personeelsnummer in. Heeft u de medewerker gevonden? Dan kunt u klikken op de regel, u gaat dan naar de details van deze medewerker. Daar kunt u de historie van de gegevens bekijken of een nieuw verzuim registreren.',
    'details-title': 'Werknemer details',
    'new-title': 'Nieuwe werknemer toevoegen',
    'create-new': 'Nieuwe werknemer toevoegen',
    // 'details-description': 'Dit is de detail pagina voor de werknemer [[full-name]]. U vindt hier een verzameling van [[possesive]] gegevens. U kunt voor deze gegevens verder navigeren naar hun eigen detail-pagina. Ook kunt u voor [[full-name]] een nieuw verzuim indienen.',
    'details-description': 'Dit is de detail pagina voor de werknemer [[full-name]]. Hier kunt u [[possesive]] persoonlijke en werkgerelateerde gegevens vinden. Onder het kopje gekoppelde polisgegevens vindt u de polissen waaraan [[full-name]] deelneemt. Verder kunt u [[possesive]] verzuimhistorie raadplegen onder het kopje \'Verzuim\'. Wanneer u op een regel klikt navigeert u naar de detail-pagina van het betreffende verzuim.',
    'form': {
      'new-description': 'Nieuwe werknemer toevoegen tekst. Lorem Ipsum is slechts een proeftekst uit het drukkerij- en zetterijwezen. Lorem Ipsum is de standaard proeftekst in deze bedrijfstak sinds de 16e eeuw, toen een onbekende drukker een zethaak met letters nam en ze door elkaar husselde om een font-catalogus te maken.',
      'new-personal-description': 'Nieuwe werknemer toevoegen persoonlijke gegevens tekst tekst. Lorem Ipsum is slechts een proeftekst uit het drukkerij- en zetterijwezen. Lorem Ipsum is de standaard proeftekst in deze bedrijfstak sinds de 16e eeuw, toen een onbekende drukker een zethaak met letters nam en ze door elkaar husselde om een font-catalogus te maken.',
      'new-employment-description': 'Werkgerelateerde gegevens tekst tekst. et heeft niet alleen vijf eeuwen overleefd maar is ook, vrijwel onveranderd, overgenomen in elektronische letterzetting. Het is in de jaren \'60 populair geworden met de introductie van Letraset vellen met Lorem Ipsum passages en meer recentelijk door desktop publishing software zoals Aldus PageMaker die versies van Lorem Ipsum bevatten.',
      'new-confirmation-description': 'Bevestiging gegevens tekst tekst. In tegenstelling tot wat algemeen aangenomen wordt is Lorem Ipsum niet zomaar willekeurige tekst. het heeft zijn wortels in een stuk klassieke latijnse literatuur uit 45 v.Chr.',

      'confirm-and-create': 'Bevestig en voeg toe',
      'confirming-and-creating': 'Werknemer aan het toevoegen ..',
      'confirm-and-update-personal': 'Wijzig persoonsgegevens',
      'confirming-and-updating-personal': 'Persoonsgegevens aan het wijzigen ..',

      'yes-absence-on-employment-from-date': 'Ja, de werknemer was ziek.',
      'no-absence-on-employment-from-date': 'Nee, dat was niet zo.'
    },

    'toasters': {
      'navigated-new-report-of-sickness-for-employee': 'Genavigeerd naar Nieuw Verzuim, waar [[initials]] [[last-name]] alvast is geselecteerd'
    }
  },

  'profession-classification': {
    'Undefined': 'Niet gespecificeerd',
    'undefined': 'Niet gespecificeerd',
    'null': 'Niet gespecificeerd',
    '0': 'Niet gespecificeerd',
    '1': 'Administratief',
    'A': 'Administratief',
    '2': 'Commercieel',
    'M': 'Commercieel',
    '3': 'Reizend',
    '4': 'Handenarbeid',
    'F': 'Handenarbeid',
    '5': 'Zware arbeid'
  },

  'nature-of-employment': {
    'Undefined': 'Niet gespecificeerd',
    'undefined': 'Niet gespecificeerd',
    'null': 'Niet gespecificeerd',
    '0': 'Niet gespecificeerd',
    '1': 'Vast',
    '2': 'DGA',
    '3': 'Oproepkracht met verschijningsplicht',
    '4': 'Oproepkracht zonder verschijningsplicht',
    '5': 'Stagiair',
    '6': 'Uitzendkracht',
    '7': "Herintredende WAO'ers",
    '8': 'WIW art. 4',
    '9': 'Tijdelijk',
    '10': 'Oproepkracht'
  },

  'period': {
    'general': {
      'change-in-absence': 'Wijziging in verzuim'
    },
    'new': {
      'title': 'Wijziging in verzuim doorgeven',
      'description': 'Hier kunt u een wijziging in het verzuim doorgeven, zoals een deelherstel.'
    },
    'edit': {
      'title': 'Bewerken wijziging in verzuim',
      'description': 'U heeft eerder een wijziging in het verzuim doorgegeven. Met onderstaand formulier kunt u de wijziging in het verloop van het verzuim nog eens bewerken. De waarden die u kunt veranderen zijn alvast ingevuld in de velden hieronder.'
    },
    'form': {
      'selected-employee': 'Werknemer',
      'selected-employee-description': 'De werknemer in kwestie voor de wijziging in verzuim.',
      'start-date': 'Ingangsdatum wijziging',
      'start-date-description': 'Op deze datum is de wijziging voor het eerst opgetreden.',

      'confirm-and-create': 'Bevestig en verstuur wijziging',
      'confirming-and-creating': 'Wijziging aan het versturen ..',

      'confirm-and-update': 'Bevestig en bewerk wijziging',
      'confirming-and-updating': 'Wijziging aan het bewerken ..'
    },
    'modals': {
      'delete-period-confirmation-title': 'Wijziging verwijderen',
      'delete-period-confirmation-text': 'Weet u zeker dat u de wijziging in het verzuim voor [[employee.name]] op [[period.start-date]] wilt verwijderen?',

      'delete-processed-period-confirmation-title': 'Deelherstel verwijderen',
      'delete-processed-period-confirmation-text': 'Het deelherstel is al opgenomen in de schade berekening. Het deelherstel zal verwijderd worden. Een eventuele reeds uitgekeerde schade zal gecorrigeerd worden. Deze correctie zal op de eerstvolgende uitkering-specificatie worden vermeld. Weet u zeker dat u het deelherstel voor [[employee.name]] op [[period.start-date]] wilt verwijderen?',

      'edit-processed-period-confirmation-title': 'Deelherstel wijzigen',
      'edit-processed-period-confirmation-text': 'Het deelherstel is al opgenomen in de schade berekening. U kunt het deelherstel alsnog wijzigen. Een eventuele reeds uitgekeerde schade zal gecorrigeerd worden. Deze correctie zal op de eerstvolgende uitkering-specificatie worden vermeld. Weet u zeker dat u het deelherstel voor [[employee.name]] op [[period.start-date]] wilt wijzigen?',

      'new-disabled-due-to-processing-title': 'Deelherstel doorgeven',
      'new-disabled-due-to-processing-text': 'U kunt geen nieuw deelherstel aanmaken. Op dit moment wordt schade berekend en verwerkt. U kunt geen mutaties op verzuimen doorgeven.',
      'new-disabled-due-to-same-date-text': 'U kunt geen nieuw deelherstel aanmaken.  Er bestaat voor vandaag al een nieuw deelherstel. Wilt u het vandaag aangemaakte deelherstel nog corrigeren? Wijzig dan het betreffende deelherstel.',
      'new-disabled-due-to-same-date-title': 'Deelherstel doorgeven',
      'new-disabled-previous-is-reviewing-text': 'U kunt geen nieuwe deelherstel melding aanmaken. De voorgaande melding wordt nog beoordeeld.',
      'new-disabled-previous-is-reviewing-title': 'Voorgaande melding nog ter beoordeling.',
      'new-disabled-previous-is-not-approved-or-processed-title': 'Voorgaande melding in ongeldige status',
      'new-disabled-previous-is-not-approved-or-processed-text': 'U kunt geen nieuwe deelherstel melding maken. De voorgaande melding bevindt zich in een blokkerende status.',
      'edit-currently-processing-period-title': 'Deelherstel bewerken',
      'edit-currently-processing-period-text': 'Op dit moment wordt de schade uitkering berekend. U kunt het deelherstel niet bewerken.',
      'delete-currently-processing-period-title': 'Deelherstel verwijderen',
      'delete-currently-processing-period-text': 'Op dit moment wordt de schade uitkering berekend. U kunt het deelherstel niet verwijderen.',
      'picked-date-will-trigger-correction-title': 'Correctie op schadeberekening',
      'picked-date-will-trigger-correction-text': 'De door u gekozen ingangsdatum van de wijziging zal een correctie in de schade berekening ten gevolgen hebben. Weet u zeker dat u [[picked-date]] wilt kiezen als de ingangsdatum van de wijziging?',
      'picked-date-will-trigger-correction-confirm': 'Ik wil de datum wijzigen'
    }
  },

  'recovery': {
    'general': {
      'recovery-report': 'Herstelmelding'
    },
    'edit': {
      'title': 'Herstelmelding wijzigen',
      'description': 'Met dit formulier kunt u een eerder gemeld herstel wijzigen.'
    },
    'new': {
      'title': 'Volledig herstel doorgeven',
      'description': 'Met dit formulier kunt u een volledig herstel doorgeven. Dit betekent een arbeidsongeschiktheidspercentage van 0%. We vragen u om de datum waarom de werknemer hersteld is.'
    },
    'form': {
      'recovery-date': 'Herstel datum',
      'recovery-date-description': 'Wat is de datum dat uw werknemer volledig hersteld is?',
      'selected-employee': 'Werknemer',
      'selected-employee-description': 'De werknemer in kwestie voor volledig herstel.',

      'confirm-and-create': 'Bevestig en verstuur herstel',
      'confirming-and-creating': 'Herstel aan het versturen ..'
    },
    'modals': {
      'delete-recovery-confirmation-title': 'Herstelmelding verwijderen',
      'delete-recovery-confirmation-text': 'Weet u zeker dat u de herstelmelding voor [[employee.name]] op [[report-of-sickness.recovery-date]] wilt verwijderen?',

      'delete-processed-recovery-confirmation-title': 'Herstelmelding verwijderen',
      'delete-processed-recovery-confirmation-text': 'De herstelmelding is al opgenomen in de schade berekening. De herstelmelding zal verwijderd worden. Een eventuele reeds uitgekeerde schade zal gecorrigeerd worden. Deze correctie zal op de eerstvolgende uitkering-specificatie worden vermeld. Weet u zeker dat u de herstelmelding voor [[employee.name]] op [[report-of-sickness.recovery-date]] wilt verwijderen?',

      'edit-processed-recovery-confirmation-title': 'Herstelmelding wijzigen',
      'edit-processed-recovery-confirmation-text': 'De herstelmelding is al opgenomen in de schade berekening. U kunt de herstelmelding alsnog wijzigen. Een eventuele reeds uitgekeerde schade zal gecorrigeerd worden. Deze correctie zal op de eerstvolgende uitkering-specificatie worden vermeld. Weet u zeker dat u de herstelmelding voor [[employee.name]] op [[report-of-sickness.recovery-date]] wilt wijzigen?',

      'new-disabled-due-to-processing-title': 'Volledig herstel doorgeven',
      'new-disabled-due-to-processing-text': 'U kunt geen volledig herstel doorgeven. Op dit moment wordt schade berekend en verwerkt. U kunt geen mutaties op verzuimen doorgeven.',
      'new-disabled-due-to-same-date-period-text': 'U kunt geen volledig herstel doorgeven. Er bestaat voor vandaag al een nieuw deelherstel. Wilt u het vandaag aangemaakte deelherstel nog corrigeren? Wijzig dan het betreffende deelherstel.',
      'new-disabled-due-to-same-date-period-title': 'Volledig herstel doorgeven',
      'new-disabled-due-to-same-date-report-of-sickness-text': 'U kunt geen volledig herstel doorgeven. Er bestaat voor vandaag al een nieuwe verzuimmelding. Wilt u het vandaag aangemaakte verzuim nog corrigeren? Wijzig dan het betreffende verzuim.',
      'new-disabled-due-to-same-date-report-of-sickness-title': 'Volledig herstel doorgeven',
      'new-disabled-due-to-next-date': 'U kunt geen volledig herstel in de toekomst melden',
      'new-disabled-previous-is-reviewing-text': 'U kunt geen volledig herstel doorgeven. De voorgaande melding wordt nog beoordeeld.',
      'new-disabled-previous-is-reviewing-title': 'Voorgaande melding nog ter beoordeling.',
      'new-disabled-previous-is-not-approved-or-processed-title': 'Voorgaande melding in ongeldige status',
      'new-disabled-previous-is-not-approved-or-processed-text': 'U kunt geen volledig herstel doorgeven. De voorgaande melding bevindt zich in een blokkerende status.',
      'edit-currently-processing-recovery-title': 'Herstelmelding bewerken',
      'edit-currently-processing-recovery-text': 'Op dit moment wordt de schade uitkering berekend. U kunt de herstelmelding niet bewerken.',
      'delete-currently-processing-recovery-title': 'Herstelmelding verwijderen',
      'delete-currently-processing-recovery-text': 'Op dit moment wordt de schade uitkering berekend. U kunt de herstelmelding niet verwijderen.',
      'picked-date-will-trigger-correction-title': 'Correctie op schadeberekening',
      'picked-date-will-trigger-correction-text': 'De door u gekozen ingangsdatum van herstel zal een correctie in de schade berekening ten gevolgen hebben. Weet u zeker dat u [[picked-date]] wilt kiezen als de ingangsdatum van herstel?',
      'picked-date-will-trigger-correction-confirm': 'Ik wil de datum wijzigen'
    }
  },

  'report-of-sickness': {
    'general': {
      'first-of-absence': 'Eerste verzuimdag'
    },
    'overview': 'Overzicht verzuimen',
    'detail': 'Verzuim details',
    'new-report-of-sickness': 'Nieuw verzuim',
    'create-new': 'Nieuw verzuim indienen',

    'safetynet': 'Vangnet',
    'accident': 'Ongeval',
    'disability-rate': 'Arbeidsongeschiktheidspercentage',
    'disability-rate-abrev': 'Percentage',
    'arbo-report': 'ARBO rapportage',
    'first-of-absence': 'Eerste verzuimdag',
    'third-party-liability': 'Aansprakelijke derde',
    'None': 'Geen',
    'NoThirdPartyLiability': 'Geen aansprakelijk derde',
    'ThirdPartyLiability': 'Aansprakelijke derde',

    'links': {
      'detail-title': 'Wat wilt u doen met dit verzuim?',
      'report-part-recovery': 'Ik wil een wijziging in het verzuim doorgeven',
      'report-complete-recovery': 'Ik wil een volledig herstel melden'
    },

    'states': {
      'Received': 'Ontvangen',
      'Approved': 'Goedgekeurd',
      'Rejected': 'Afgekeurd',
      'ToReview': 'Ter beoordeling',
      'Processing': 'In behandeling',
      'Removed': 'Verwijderd',
      'Corrected': 'Gecorrigeerd',
      'Processed': 'Verwerkt',
      'Modified': 'Aangepast',
      'Open': 'Lopend',
      'Closed': 'Gesloten',
      'RemovedForCorrection': 'Verwijderd ter correctie'
    },

    'details': {
      'processed-until-date-header-element-description': 'Voor onderstaande meldingen is schade berekend.',
      'processed-until-date-text': 'Op [[processed-date]] zijn uw meldingen verwerkt in de schade berekeningen. Voor deze versie van onze verzuim portaal betekent dat dat u onderstaande meldingen niet meer kunt wijzigen of verwijderen. Is er toch iets misgegaan, neem dan contact op met onze klantenservice.'
    },

    'form': {
      'new-description-wia-only': 'Hieronder kunt u uw werknemer ziekmelden. Dit doet u binnen vijf werkdagen na de eerste ziektedag als u een verzuimverzekering heeft afgesloten. Heeft u alléén een WIA verzekering afgesloten, dan ontvangen we de ziekmelding graag rond de dertiende week na de eerste ziektedag. Meldt u uw werknemer later ziek, dan kunnen er aanvullende vragen worden gesteld of gegevens worden opgevraagd.',
      'new-description-vzm-only': 'Hieronder kunt u uw werknemer ziekmelden. Dit doet u binnen vijf werkdagen na de eerste ziektedag als u een verzuimverzekering heeft afgesloten. Heeft u alléén een WIA verzekering afgesloten, dan ontvangen we de ziekmelding graag rond de dertiende week na de eerste ziektedag. Meldt u uw werknemer later ziek, dan kunnen er aanvullende vragen worden gesteld of gegevens worden opgevraagd.',
      'new-description-multi': 'Hieronder kunt u uw werknemer ziekmelden. Dit doet u binnen vijf werkdagen na de eerste ziektedag als u een verzuimverzekering heeft afgesloten. Heeft u alléén een WIA verzekering afgesloten, dan ontvangen we de ziekmelding graag rond de dertiende week na de eerste ziektedag. Meldt u uw werknemer later ziek, dan kunnen er aanvullende vragen worden gesteld of gegevens worden opgevraagd.',

      'new-confirmation-description-wia-only': 'Hieronder kunt u uw werknemer ziekmelden. Dit doet u binnen vijf werkdagen na de eerste ziektedag als u een verzuimverzekering heeft afgesloten. Heeft u alléén een WIA verzekering afgesloten, dan ontvangen we de ziekmelding graag rond de dertiende week na de eerste ziektedag. Meldt u uw werknemer later ziek, dan kunnen er aanvullende vragen worden gesteld of gegevens worden opgevraagd.',
      'new-confirmation-description-vzm-only': 'Hieronder kunt u uw werknemer ziekmelden. Dit doet u binnen vijf werkdagen na de eerste ziektedag als u een verzuimverzekering heeft afgesloten. Heeft u alléén een WIA verzekering afgesloten, dan ontvangen we de ziekmelding graag rond de dertiende week na de eerste ziektedag. Meldt u uw werknemer later ziek, dan kunnen er aanvullende vragen worden gesteld of gegevens worden opgevraagd.',
      'new-confirmation-description-multi': 'Hieronder kunt u uw werknemer ziekmelden. Dit doet u binnen vijf werkdagen na de eerste ziektedag als u een verzuimverzekering heeft afgesloten. Heeft u alléén een WIA verzekering afgesloten, dan ontvangen we de ziekmelding graag rond de dertiende week na de eerste ziektedag. Meldt u uw werknemer later ziek, dan kunnen er aanvullende vragen worden gesteld of gegevens worden opgevraagd.',

      'detail-description': 'In dit overzicht vindt u de details van een verzuimperiode per werknemer. Is de verzuimperiode nog niet afgesloten dan kunt u hier een nieuw deelherstel of volledig herstel registreren middels de hiernaast genoemde buttons. Wilt u een reeds gedane laatste deelherstel of volledig herstel corrigeren? Klik dan op de \'wijzigen\' of \'verwijder\' button die behoort bij het laatste deelherstel of hersteldatum.',
      'edit-description': 'Met onderstaand formulier kunt u een wijziging aanbrengen in uw eerder aangemaakte ziekmelding. Wanneer u de wijziging aan de ziekmelding heeft ingediend, krijgt u van ons bericht per e-mail. Ook kunt u de status van uw claim inzien op de verzuim pagina van deze portal.',
      'index-description': 'In dit overzicht vindt u alle verzuimperiodes van uw werknemers welke bij ons bekend zijn. U kunt een specifiek verzuim vinden door de onderstaande tabel te filteren. Zo kunt u (door middel van de onderstaande balk) een zoekopdracht invoeren, de periode waarin het verzuim valt bepalen en alléén lopende óf gesloten verzuimen laten zien.  Wilt u per verzuimperiode meer details zien? Selecteer dan de regel door er op te klikken. Hier vindt u de historie en kunt u wijzigingen doorgeven of herstel melden.',
      'select-employee': 'Selecteer een werknemer.',

      'safetynet-description': 'Is er sprake van een vangnet? UWV vergoedt dan de loondoorbetaling.',
      'accident-description': 'Is er sprake van een ongeval?',
      'third-party-liability-description': 'Is er sprake van aansprakelijkheid door derden?',
      'arbo-report-description': 'De datum is langer dan vijf werkdagen geleden. We vereisen een ARBO rapportage.',
      'first-of-absence-description': 'Wat is de eerste verzuimdag?',
      'disability-rate-description': 'Voor hoeveel procent verzuimt uw werknemer?',

      'no-entry': 'Niet ingevuld.',
      'no-there-isnt': 'Nee, dat is er niet.',
      'yes-accident': 'Ja, er is sprake van een ongeval.',
      'no-accident': 'Nee, er is geen sprake van een ongeval.',
      'yes-safetynet': 'Ja, er is sprake van een vangnet.',
      'no-safetynet': 'Nee, er is geen sprake van een vangnet.',
      'yes-third-party-liability': 'Ja, er is een aansprakelijke derde.',
      'no-third-party-liability': 'Nee, er is (nog) geen aansprakelijke derde.',
      'accident-type': {
        'none': 'Geen',
        'third-party-liability': 'Aansprakelijke derde',
        'no-third-party-liability': 'Ja'
      },
      'safety-net': {
        'true': 'Ja',
        'false': 'Nee'
      },

      'creating-report-of-sickness': 'Verzuim wordt aangemaakt ..',
      'updating-report-of-sickness': 'Verzuim wordt gewijzigd ..',
      'confirm-and-create-report-of-sickness': 'Bevestig en verstuur verzuim'
    },

    'warnings': {
      'one-month-since-last-closed': 'U heeft een nieuwe ziekmelding geregistreerd voor een werknemer die minder dan 28 dagen geleden hersteld was. In dit geval worden de dagen van zijn vorige arbeidsongeschiktheid opgeteld bij deze nieuwe ziekteperiode.'
    },

    'modals': {
      'delete-report-of-sickness-confirmation-title': 'Verzuim verwijderen',
      'delete-report-of-sickness-confirmation-text': 'Weet u zeker dat u het verzuim voor [[employee.name]] op [[report-of-sickness.first-of-absence]] wilt verwijderen?',
      'first-of-absence-during-or-before-existing-report-of-sickness-title': 'Foutieve eerste verzuimdag',
      'first-of-absence-during-or-before-existing-report-of-sickness-text': 'De door u ingevoerde datum "eerste verzuimdag" kan niet worden verwerkt. De werknemer is al ziekgemeld op deze datum. Wijzig de datum “eerste verzuimdag” of geef een (deel)herstel door.',
      'edit-processed-confirmation-title': 'Verzuim bewerken',
      'edit-processed-confirmation-text': 'Het verzuim is al opgenomen in de schade berekening. De wijziging(en) in het verzuim zal/zullen verwerkt worden. Een eventuele reeds uitgekeerde schade zal gecorrigeerd worden. Deze correctie zal op de eerstvolgende uitkering-specificatie worden vermeld. Weet u zeker dat u het verzuim alsnog wilt bewerken?',
      'delete-processed-confirmation-title': 'Verzuim verwijderen',
      'delete-processed-confirmation-text': 'Het verzuim is al opgenomen in de schade berekening. U kunt het verzuim alsnog verwijderen. Een eventuele reeds uitgekeerde schade zal gecorrigeerd worden. Deze correctie zal op de eerstvolgende uitkering-specificatie worden vermeld. Weet u zeker dat het verzuim voor [[employee.name]] op [[report-of-sickness.first-of-absence]] wilt verwijderen?',

      'edit-currently-processing-report-of-sickness-title': 'Verzuim bewerken',
      'edit-currently-processing-report-of-sickness-text': 'Op dit moment wordt de schade uitkering berekend. U kunt het verzuim niet bewerken.',
      'delete-currently-processing-report-of-sickness-title': 'Verzuim verwijderen',
      'delete-currently-processing-report-of-sickness-text': 'Op dit moment wordt de schade uitkering berekend. U kunt het verzuim niet verwijderen.',

      'new-period-disabled-due-to-same-date-title': 'Deelherstel doorgeven',
      'new-period-disabled-due-to-same-date-text': 'U kunt geen nieuw deelherstel aanmaken. Er bestaat voor vandaag al een nieuw verzuim. Wilt u het vandaag aangemaakte verzuim nog corrigeren? Wijzig dan het betreffende verzuim.'
    }
  },

  'reports-of-sickness-import': {
    'new-title': 'Nieuwe Verzuimen Importeren',
    'new-description': 'Met onderstaand formulier kunt u nieuwe verzuimen importeren. We vragen u een .CSV bestand volgens een specifiek formaat aan te leveren. Dit wordt door ons systeem ingelezen waarop een rapportage van het importeerproces volgt.',

    'fields': {
      'import-file': 'Importeer Bestand'
    },
    'guides': {
      'import-file': 'Het *.csv bestand waarin de te importeren verzuimen zijn opgeslagen.'
    }
  },

  'policy': {
    'policy': 'Polis',
    'policy-number': 'Polisnummer',
    'participation': 'Deelname',
    'participation-start-date': 'Ingangsdatum deelname',
    'participation-end-date': 'Einddatum deelname',
    'waiver-start-date': 'Ingangsdatum afstandsverklaring ',
    'waiver-end-date': 'Einddatum afstandsverklaring'
  },
  'policies': {
    'policies-with-coverage': 'Polissen met dekking voor deze werknemer',
    'policies-distance-declaration': 'Polissen met afstandsverklaring',
    'policies-without-coverage': 'Polissen zonder dekking',
    'policies': 'Polissen',

    'errors': {
      'none-found': {
        'title': 'Geen polissen gevonden!',
        'description': 'Er zijn geen polissen gevonden.'
      },
      'none-found-for-employee': {
        'title': 'Geen polissen gevonden!',
        'description': 'Er zijn geen in aanmerking komende (lees: actieve) polissen gevonden waar de werknemer actief aan deelneemt.'
      }
    }
  },

  'uwv-decision': {
    'new-uwv-decision': 'UWV beslissing doorgeven',
    'new-header-text': 'De gegevens omtrent de UWV beslissing van uw werknemer, kunt u via onderstaand formulier aan ons doorgeven. Wij ontvangen graag ook het document. Deze kunt u uploaden in het bijlage-veld.',
    'types': {
      'WageRelatedBenefit': 'Loongerelateerde uitkering',
      'WageSupplementBenefit': 'Loonaanvullingsuitkering',
      'FollowUpBenefit': 'Vervolguitkering',
      'IVABenefit': 'IVA-uitkering',
      'WagePenaly': 'Loonsanctie',
      'LessThanThirtyFivePercent': 'Minder dan 35%',
      'Miscellaneous': 'Overige wijzigingen'
    },
    'modals': {
      'new-disabled-previous-is-reviewing-text': 'U kunt geen nieuwe UWV beslissing doorgeven. De voorgaande melding wordt nog beoordeeld',
      'new-disabled-previous-is-reviewing-title': 'Voorgaande melding nog ter beoordeling.',
      'new-disabled-previous-is-not-approved-or-processed-title': 'Voorgaande melding in ongeldige status',
      'new-disabled-previous-is-not-approved-or-processed-text': 'U kunt geen nieuwe UWV beslissing doorgeven. De voorgaande melding bevindt zich in een blokkerende status.'
    },
    'fields': {
      'decision-type': 'Type beslissing',
      'disability-rate': 'Arbeidsongeschiktheidspercentage',
      'attachment': 'Bijlage beslissing',
      'start-date': 'Ingangsdatum beslissing',
      'report-date': 'Gerapporteerd op',
      'benefit-end-date': 'Einddatum loongerelateerde uitkering',
      'decision-date': 'Datum beslissing',
      'wia-daily-wage': 'WIA dagloon',
      'wia-monthly-wage': 'WIA maandloon',
      'income-from-work': 'Inkomsten uit arbeid',
      'status': 'Status',
      'guides': {
        'decision-type': 'Welke beslissing heeft UWV genomen?',
        'disability-rate': 'Dit vindt u in de beslissing van UWV.',
        'attachment': 'Hier kunt u de beslissing van het UWV aan ons doorgeven.',
        'start-date': 'Per welke datum gaat de beslissing in? Wat is bijvoorbeeld de ingangsdatum van de WIA-uitkering?',
        'report-date': 'Gerapporteerd op',
        'benefit-end-date': 'Einddatum loongerelateerde uitkering',
        'decision-date': 'Dit is de datum van de brief van UWV.',
        'wia-daily-wage': 'Dit vindt u in de beslissing van UWV. Vul het geindexeerde bedrag in.',
        'wia-monthly-wage': 'Dit vindt u in de beslissing van UWV.',
        'income-from-work': 'Vul hier de nieuwe inkomsten uit arbeid in. Dit bedrag is inclusief vakantiegeld en eindejaarsuitkering. U vindt het in de beslissing van UWV onder het kopje "nieuw loon" of "Uw loon".'
      }
    }
  }
};
